var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "card mt-3", attrs: { "header-bg-variant": "white" } },
        [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.subscriptionProduct
                ? _c("PremiumPlanCard", {
                    attrs: {
                      id: "product-card",
                      subscription: _vm.subscriptionProduct,
                      isPendingProduct: false,
                      isSameProductDifferentCadence:
                        _vm.isSameProductDifferentCadence,
                      apparatusesNeedsAttention: _vm.apparatusesNeedsAttention,
                      premiumSubscriptionApparatusMultiplePlans:
                        _vm.premiumSubscriptionApparatusMultiplePlans
                    },
                    on: {
                      openCancelPlanMultiplePlansModal: function($event) {
                        return _vm.$emit("openCancelPlanMultiplePlansModal")
                      }
                    }
                  })
                : _vm._e(),
              _vm.subscription.subscriptionStatus ===
                _vm.subscriptionDetailPendingCancel ||
              _vm.subscription.subscriptionStatus ===
                _vm.subscriptionDetailPendingProductChange
                ? _c(
                    "div",
                    [
                      _c("hr"),
                      _vm.subscriptionPendingProduct
                        ? _c("PremiumPlanCard", {
                            attrs: {
                              id: "pending-product-card",
                              subscription: _vm.subscriptionPendingProduct,
                              isPendingProduct: true,
                              isSameProductDifferentCadence:
                                _vm.isSameProductDifferentCadence,
                              apparatusesNeedsAttention:
                                _vm.apparatusesNeedsAttention,
                              premiumSubscriptionApparatusMultiplePlans:
                                _vm.premiumSubscriptionApparatusMultiplePlans
                            },
                            on: {
                              openCancelPlanMultiplePlansModal: function(
                                $event
                              ) {
                                return _vm.$emit(
                                  "openCancelPlanMultiplePlansModal"
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c("ManagePlanModal", { attrs: { subscription: _vm.subscription } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }